import moment from 'moment'
import { Toast } from 'buefy'

function ToastError (error, duration, debugValues) {
  let msgTpl
  if (debugValues) {
    // create html for debug values
    msgTpl = '<div class="toast-container" style="max-width: 800px">'
    for (let [key, value] of Object.entries(debugValues || {})) {
      msgTpl += `
      <div class="toast-item">
        ${key}
      </div>
      <div class="toast-item">
        ${JSON.stringify(value)}
      </div>`
    }
    msgTpl += '</div>'
    // append hr if debugValues
    msgTpl += '<hr>'
    // append error message
    msgTpl += `<div>${error}</div>`
  }

  Toast.open({
    duration: duration || 5000,
    message: msgTpl || error,
    position: 'is-bottom',
    type: 'is-carnelian',
    queue: false
  })
}

function ToastErrorGraphQL ({errors, duration}) {
  let msgTpl = `A GraphQL error has occurred:<br><br>`

  errors.forEach(error => {
    msgTpl += `${error.message}<br>`
  })

  Toast.open({
    duration: duration || 5000,
    message: msgTpl || 'A GraphQL error has occurred',
    position: 'is-bottom',
    type: 'is-carnelian',
    queue: false
  })
}

function ToastSuccess (msg, duration) {
  Toast.open({
    duration: duration || 5000,
    message: msg,
    position: 'is-bottom',
    type: 'is-aquamarine'
  })
}

function CopyToClipboard (text) {
  return new Promise((resolve, reject) => {
    // fallback if navigator.clipboard will not be supported by browser
    if (!navigator.clipboard) {
      let textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.bottom = 0
      textArea.style.left = 0
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        let successful = document.execCommand('copy')
        let msg = successful ? 'successful' : 'unsuccessful'
        document.body.removeChild(textArea)
        console.log('Fallback: Copying text command was ' + msg)
        if (msg === 'successful') {
          resolve()
        } else {
          reject()
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
        document.body.removeChild(textArea)
        reject()
      }
    }
    // default clipboard function
    navigator.clipboard.writeText(text).then(() => {
      console.log('Async: Copying to clipboard was successful!')
      resolve()
    }, (err) => {
      console.error('Async: Could not copy text: ', err)
      reject()
    })
  })
}

/**
 * Detect Microsoft Browser (IE or Edge)
 * returns version of IE or false, if browser is not Internet Explorer
 * >= 12 : Edge
 * < 12  : IE
 * codepen: https://codepen.io/gapcode/pen/vEJNZN
 */
function DetectMSBrowser () {
  var ua = window.navigator.userAgent

  var msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  var trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  var edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}

// returns true if version `alt` is lower than version `neu`
// `alt` and `neu` are expected to be string of the
// form 'v0.31.2' or similar
export const isLowerVersion = (alt, neu) => {
  const toVersionInts = (versionString) => {
    return versionString.slice(1).split('.').map(x => Number(x))
  }

  const zip = (arr, ...arrs) => {
    return arr.map((val, i) => arrs.reduce((a, arr) => [...a, arr[i]], [val]))
  }

  let valt = toVersionInts(alt)
  let vneu = toVersionInts(neu)
  let comparison = zip(valt, vneu)

  return comparison.reduce((acc, [a, n]) => acc || (a < n), false)
}

export const dateFormatter = (date, locale) => {
  return (locale ? moment(date, moment.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : moment(date))
    .format('L')
}

export const timestampFormatter = (timestamp, locale) => {
  return (locale ? moment(timestamp, moment.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : moment(timestamp))
    .format('LL, LT')
}

export const timestampAsDate = (timestamp, locale) => {
  return (locale ? moment(timestamp, moment.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : moment(timestamp))
    .format('L')
}

export const fromNow = (timestamp, locale) => {
  return (locale ? moment(timestamp, moment.ISO_8601).locale(locale === 'de' ? 'de' : 'en-gb') : moment(timestamp))
    .fromNow()
}

export const currentDateString = (locale) => {
  return locale ? moment().locale(locale === 'de' ? 'de' : 'en-gb').format('LL, LT') : moment().format('LL, LT')
}

export { ToastError, ToastErrorGraphQL, ToastSuccess, CopyToClipboard, DetectMSBrowser }



// WEBPACK FOOTER //
// ./src/utils/index.js